import React, { Component } from "react";
import { connect } from "react-redux";
import { View, ScrollView } from "react-native";

import { translate } from "../../locales/translate";

import PropTypes from "prop-types";
import SearchableDropdown from "../SearchableDropDown";

/**
  @augments {Component<props, state>}
 */
class RunScenarioActionPicker extends Component {
  static propTypes = {
    selectedScenarioId: PropTypes.number,
    callerScenarioId: PropTypes.number,
    onChange: PropTypes.func,
    //onDelete: PropTypes.func,
    style: PropTypes.shape(),
  };

  constructor(props) {
    super(props);
    let { selectedScenarioId } = this.props;
    this.state = {
      selectedScenarioId,
    };

    this._scenarios = [];
    for (var i in this.props.reducer.scenarios) {
      // skip adding self to prevent infinite loop
      if (
        (this.props.callerScenarioId &&
          this.props.callerScenarioId == this.props.reducer.scenarios[i].id) ||
        this.props.callerScenarioId == this.props.reducer.scenarios[i].uId
      ) {
        continue;
      }

      // skip adding if already call another scenario, in order to prevent chain or loop actions.
      if (
        this.props.reducer.scenarios[i].runScenarioActions &&
        this.props.reducer.scenarios[i].runScenarioActions.length > 0
      ) {
        continue;
      }
      this._scenarios.push(this.props.reducer.scenarios[i]);
    }

    this._style = this.props.style || {};
  }

  componentDidMount() {
    // this._scenarios = this.props.reducer.scenarios;
  }

  handleOnSelect = (id, name) => {
    this.setState({ selectedScenarioId: id });
    this.props.onChange && this.props.onChange(id, name);
  };

  handleOnDelete() {
    this.props.onDelete && this.props.onDelete();
  }

  render() {
    return (
      <View style={{ ...this._style, flexDirection: "row", flex: 1 }}>
        <ScrollView style={{ flex: 1 }}>
          <SearchableDropdown
            clearable={true}
            items={this._scenarios.map((sc) => {
              return { id: sc.id || sc.uId, name: sc.name };
            })}
            //noItemText={translate("app.selectAnItem")}
            searchText={translate("app.selectAnItem")}
            selectedValue={this.props.selectedScenarioId}
            onSelect={this.handleOnSelect}
          />
        </ScrollView>
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    reducer: state.ScenarioReducer,
  };
};

export default connect(mapStateToProps)(RunScenarioActionPicker);
